import { compose, withState } from 'recompose'
import BaseComponent from '../BaseComponent'
// import PropTypes from 'prop-types'
import MakePage from '../pages/Make'
import React from 'react'
import { withRouter } from 'react-router'

export default compose(withRouter, withState('title', 'setTitle', ''))(
	class MakeContainer extends BaseComponent {
		constructor(props) {
			super()
			this.state = {
				loading: true,
				exercises: {}
			}
		}

		componentWillMount() {
			this.props.setTitle(this.props.match.params.title, () => {
				// eslint-disable-next-line no-process-env
				const functionBase = process.env.REACT_APP_FIREBASE_functionBase
				console.log(`TODO: Use ${functionBase}/... to get similar exercises`)
				/*
				fetch(`${functionBase}similarExercises/${title}`)
					.then(response => response.json())
					.then(exercises => this.setState({ exercises, loading: false }))
				*/
			})
		}

		render() {
			return (
				<MakePage
					{...this.state}
					title={this.props.title}
					setTitle={this.props.setTitle}
				/>
			)
		}
	}
)



// WEBPACK FOOTER //
// ./src/containers/MakeContainer.js